export default __webpack_public_path__ + "static/char-59-1fd990e91152d1f06a12189d766a50a4.gif";